import type { ModuleDefinition } from '../types';

export const sharedMailboxesModule: ModuleDefinition = {
  key: 'shared-mailboxes',
  milestone: 'M10',
  network: {
    path: 'shared-mailboxes',
    permission: 'study.network.read',
    labelKey: 'sharedMailboxes',
  },
  tenant: {
    path: 'shared-mailboxes',
    permission: 'study.read',
    labelKey: 'sharedMailboxes',
  },
  load: () => import('./SharedMailboxesModule'),
};
